import React from "react";
import styles from "./UserDetail.module.scss";
import GenButton from "./GenButton";
import {ReactComponent as Closer} from './../assets/close.svg';
import {DataService} from './../store/DataService';
import { Date24 } from "../AppConstants";
import AlertBox from "./AlertBox";


const UserDetail = (props) => {
    const [locvalue,setLocValue] = React.useState(0);
    const [rolevalue,setRoleValue] = React.useState(0);
    const [showallprac,setShowAllPrac] = React.useState(false);
    const dataservice = new DataService({guid:props.globals.sessionguid});
    const lnref = React.useRef();
    const fnref = React.useRef();
    const miref = React.useRef();
    const emref = React.useRef();
    const unref = React.useRef();
    const acrefy = React.useRef();
    const acrefn = React.useRef();
    const pwref = React.useRef();
    const pwcref = React.useRef();
    const fprefy = React.useRef();
    const fprefn = React.useRef();
    const qidref = React.useRef(null);
    const qphref = React.useRef(null);

    let newinputs = {};
    let alls = props.userdata.allservices || [];
    alls.forEach((s)=> {
        newinputs["svcopt_"+s.stid] = false;
    })
    alls = props.user.msgtypeskills || [];
    alls.forEach((svc)=> {
        newinputs["svcopt_"+svc] = true;
    })
    alls = props.userdata.allsystems || [];
    alls.forEach((s) => {
        newinputs["sysopt_"+s.stid] = false;
    })
    alls = props.user.systemskills || [];
    alls.forEach((sys) => {
        newinputs["sysopt_"+sys.systemid] = true;
    })
    alls = props.user.practiceskills || [];
    alls.forEach((p)=> {
        newinputs["upopt_"+p.pracid] = true;
    })
    newinputs["holding"] = props.user.HoldingFlag==='Y';

    const [inputs,setInputs] = React.useState(newinputs);
    let rawSkills = props.user.skills_json || "{}";
    let skillsJson = {};
    if (typeof rawSkills === "string") {
        try {
            // Fix Python-style booleans/None if they exist (e.g. from server-side stringification)
            let sanitized = rawSkills
                .replace(/:\s*True/g, ": true")
                .replace(/:\s*False/g, ": false")
                .replace(/:\s*None/g, ": null");
            skillsJson = JSON.parse(sanitized);
        } catch (e) {
            console.error("Failed to parse skills_json, attempting direct parse:", e);
            try {
                skillsJson = JSON.parse(rawSkills);
            } catch (e2) {
                console.error("Complete JSON parse failure:", rawSkills);
                skillsJson = {};
            }
        }
    } else {
        skillsJson = rawSkills || {};
    }

    // Ensure it has the correct structure for the new logic
    if (!skillsJson.practices) skillsJson.practices = {};
    if (!skillsJson.languages) skillsJson.languages = skillsJson.language ? (Array.isArray(skillsJson.language) ? skillsJson.language : [skillsJson.language]) : ["en"];
    if (skillsJson["human-only"] === undefined) skillsJson["human-only"] = true;

    const [skills, setSkills] = React.useState(skillsJson);
    const [editingPrac, setEditingPrac] = React.useState(null);

    const allSystems = props.userdata.allsystems || [];
    const emrMap = {};
    allSystems.forEach((sys) => {
        emrMap[sys.stid] = sys.stdesc; // e.g., 1 -> "ModMed"
    });
    
    const [selprac,setSelPrac] = React.useState(0);
    const [selsys,setSelSys] = React.useState(0);
    alls = props.user.practiceskills || [];
    const [authorized,setAuthorized] = React.useState(alls);
    const [selassigned,setSelAssigned] = React.useState([]);

    const onClose = (e) => {
        props.onClose(null);
    }


    const DoSave = (id) => {
        let active = acrefy.current.checked ? 'Y' : 'N';
        let holding = inputs["holding"] ? 'Y' : 'N';
        let fpw = fprefy.current.checked;
        let expdate = "1/1/2100 00:00:00";
        if (fpw) {
            expdate = "NULL";
        }
        let pwd = props.user.Password;
        let newpw = pwref.current.value;
        let confpw = pwcref.current.value;
        if (newpw.length > 0 && newpw.length < 6) {
            AlertBox("Password MUST be at least 6 characters.");
            return;
        }
        if (newpw.length) {
            if (newpw !== confpw) {
                AlertBox("Password and Confirm Password MUST match.");
                return;
            }
            pwd = newpw;
        }
        let roleid = rolevalue;
        if (roleid < 1) {
            AlertBox("User MUST have a Role selected. Please select a Role.");
            return;
        }
        let roledesc = "";
        props.userdata.roles.forEach(obj=> {
            if (obj.RoleID===roleid) {
                roledesc = obj.Description;
            }
        });
        let locid = locvalue;
        let locdesc="";
        props.userdata.locations.forEach(obj=>{
            if (obj.LocationID===locid) {
                locdesc = obj.Name;
            }
        })

        const lname = lnref.current.value;
        const fname = fnref.current.value;
        const middle = miref.current.value;
        const uname = unref.current.value;

        if (uname.length < 6) {
            AlertBox("Username MUST be at least 6 characters.");
            return;
        }

        if (props.user.UserAccountID===0) {
            if (!newpw.length) {
                AlertBox("New User MUST be given a Password.");
                return;
            }
            if (lname.length < 1 && fname.length < 1) {
                AlertBox("New User MUST have First and Last names.");
                return;
            }
            if (uname.length < 1) {
                AlertBox("New User MUST have a User ID.");
                return;
            }
        }

        let svcs = [];
        let sysskills = [];
        let pracskills = [];
        for (let p in inputs) {
            let sa = p.split("_");
            let nm = sa[0];
            let value = sa[1];
            if (inputs[p]===true) {
                if (nm==='svcopt') {
                    svcs.push(value);
                }
                if (nm==='sysopt') {
                    sysskills.push({systemid:value,practiceid:0})
                }
                if (nm==='upopt') {
                    pracskills.push({pracid:value,mtid:0});
                }
            } 
        }

        let queueid = '';
        if (qidref.current) {
            queueid = qidref.current.value;
        }
        let queuephone = '';
        if (qphref.current) {
            queuephone = qphref.current.value;
        }

        let obj = {
            UserAccountID:props.user.UserAccountID,
            PersonID:props.user.PersonID,
            RoleID:roleid,
            LastName:lname,
            FirstName:fname,
            MiddleInitial:middle,
            Username:uname,
            Password:pwd,
            RestrictedAccess:"N",
            PasswordExpiration:expdate,
            DefaultLocationId:locid,
            PracticeId:props.globals.practiceid,
            Email:emref.current.value,
            queuetype:1,
            queueid:queueid,
            queuephonetype:2,
            queuephone:queuephone,
            Location:locdesc,
            RoleTypeId:0,
            RoleDescription:roledesc,
            ActiveFlag:active,
            HoldingFlag:holding,
            msgtypeskills:svcs,
            practiceskills:pracskills,
            systemskills:sysskills
        }

        // Finalize the nested skills JSON and flat practiceskills for server
        const cleanPractices = {};
        let updatedPracSkills = [];

        for (let p in inputs) {
            if (p.startsWith('upopt_') && inputs[p] === true) {
                const pid = p.split('_')[1];
                const prac = props.userdata.practices.find(pr => ''+pr.pracid === ''+pid);
                
                let pData = skills.practices[pid] || { 
                    emr: getPracEMRs(prac), 
                    message_types: [], 
                    holding: true 
                };

                cleanPractices[pid] = pData;
                
                // Pass to server in flat format as well
                if (pData.message_types && pData.message_types.length > 0) {
                    pData.message_types.forEach(mtid => {
                        updatedPracSkills.push({pracid: pid, mtid: mtid});
                    });
                } else {
                    updatedPracSkills.push({pracid: pid, mtid: 0});
                }
            }
        }
        obj.practiceskills = updatedPracSkills;

        // Dynamically compute global HoldingFlag based on whether any practice has holding = true
        let anyHolding = false;
        for (let pid in cleanPractices) {
            if (cleanPractices[pid].holding === true) {
                anyHolding = true;
                break;
            }
        }
        obj.HoldingFlag = anyHolding ? 'Y' : 'N';

        obj.skills_json = JSON.stringify({
            "human-only": skills["human-only"],
            "languages": skills.languages,
            "practices": cleanPractices
        });

        dataservice.updateuser(props.globals.practiceid,obj).then((data) => {
            if (data.ERROR) {
                alert(data.ERROR);
                return;
            }
            obj.UserAccountID = ''+data.UAID || '0';
            props.onClose(obj);
        });
    }

    const Buttons = () => {

        return (
            <React.Fragment>
            <div style={{display:"block"}}>
                <GenButton 
                onclick={DoSave} 
                id={props.user.UserAccountID} 
                buttontext="Save Changes"
                bgcolor="white"
                color="black"
                width="100"
                height="30"
                />
                <div style={{marginTop:"30px"}}>
                <GenButton 
                    onclick={onClose} 
                    id={props.user.UserAccountID} 
                    buttontext="Cancel Changes"
                    bgcolor="white"
                    color="black"
                    width="100"
                    height="30"
                />
                </div>
            </div>
            </React.Fragment>
        )
    }

    React.useEffect(() => {
        const dataservice = new DataService({guid:props.globals.sessionguid});
        dataservice.validatesession();
    },[props.globals.sessionguid])


    React.useEffect(()=> {
        props.userdata.locations.forEach((loc) => {
            if (loc.Name===props.user.Location) {
                setLocValue(loc.LocationID);
            }
        });
        setRoleValue(props.user.RoleID);
    },[props.userdata.locations,props.user.Location,props.user.RoleID])

    const onLocChange = (e) => {
        setLocValue(e.target.value);
    }
    const onRoleChange = (e) => {
        setRoleValue(e.target.value);
    }

    const ShowLocations = () => {
        
        let locs = [{LocationID:0,Name:""}];
        props.userdata.locations.forEach((loc) => {
            locs.push({LocationID:loc.LocationID,Name:loc.Name});
        });
        return (
            <select name="selloc" id="selloc" style={{width:"260px"}} value={locvalue} onChange={onLocChange}>
            {locs.map((loc,i)=> {
                return <option key={"locopt_"+i} value={loc.LocationID}>{loc.Name}</option>
            })}
            </select>
        )
    }

    const ShowRoles = () => {
        let rdonly = parseInt(props.user.UserAccountID || '0') === props.globals.useraccountid;

        let roles = [{RoleID:0,Description:""}];
        props.userdata.roles.forEach((role)=> {
            if (role.RoleID < 3 && props.globals.roleid < 3) {
                roles.push({RoleID:role.RoleID,Description:role.Description});
            }
            if (role.RoleTypeId > 2) {
                roles.push({RoleID:role.RoleID,Description:role.Description});
            }
        });
        return (
            <select name="selrole" id="selrole" style={{width:"170px"}} disabled={rdonly} value={rolevalue} onChange={onRoleChange}>
                {roles.map((role,i)=> {
                    return <option key={"roleopt_"+i} value={role.RoleID}>{role.Description}</option>
                })}
            </select>
        )
    }

    const checkAllSystems = (tf) => {
        const allprac = props.userdata.practices || [];
        let newobj = JSON.parse(JSON.stringify(inputs));
        allprac.forEach((prac)=> {
            const hassys = /\(([^)]+)\)/.test(prac.extended);
            if (hassys) {
                newobj["upopt_"+prac.pracid] = tf;
            }
        })
        setInputs(values => ({...values,...newobj}));
    }

    const checkAllPrac = (tf) => {
        const allprac = props.userdata.practices || [];
        let newobj = JSON.parse(JSON.stringify(inputs));
        allprac.forEach((prac)=> {
            newobj["upopt_"+prac.pracid] = tf;
        })
        setInputs(values => ({...values,...newobj}));
    }

    const getPracEMRs = (prac) => {
        if (!prac) return [];
        const pracEMRs = [];
        const matches = prac.extended.match(/\(([^)]+)\)/g);
        if (matches) {
            matches.forEach(m => {
                const name = m.slice(1, -1);
                if (!pracEMRs.includes(name)) pracEMRs.push(name);
            });
        }
        return pracEMRs;
    };

    const handleCheckboxChange = (e) => {
        let name = e.target.name;
        let value = e.target.checked;
        
        // Auto-default skills for new users when a practice is selected
        const isNewUser = props.user.UserAccountID === 0 || props.user.UserAccountID === '0';
        if (name.startsWith("upopt_") && value === true && isNewUser) {
            const pid = name.split("_")[1];
            if (!skills.practices[pid]) {
                const prac = props.userdata.practices.find(p => ''+p.pracid === ''+pid);
                if (prac) {
                    const defaults = {
                        holding: true,
                        emr: getPracEMRs(prac),
                        message_types: []
                    };
                    setSkills(prev => ({
                        ...prev,
                        practices: { ...prev.practices, [pid]: defaults }
                    }));
                }
            }
        }

        setInputs(values => ({...values,[name]:value}));
    }

    const buildSkillSel = () => {
        const users = props.userdata.users || [];
        const user = users[parseInt(props.user.UserAccountID)] || {};
        let usermt = user.msgtypeskills || [];
        let allmt = props.userdata.allmsgtypes || [];
        let foundmsgtypes = [];
        let pmt = [];
        usermt.forEach((p)=> {
            pmt.push(''+p.mtid)
        })
        allmt.forEach((mt)=> {
            if (allmt.includes(mt.mtid)) {
                if (inputs["svcopt_"+mt.mtid]===true) {
                    foundmsgtypes.push({mtid:mt.mtid,Name:mt.Name});
                }
            }
        })
        return foundmsgtypes;
    }

    const getSummary = (pracid) => {
        const pSkills = skills.practices[pracid] || {};
        const emrs = pSkills.emr || [];
        const mts = pSkills.message_types || [];
        const holding = pSkills.holding;
        
        let summary = [];
        if (holding) summary.push("Holding");
        if (emrs.length > 0) summary.push(`EMR: ${emrs.join(', ')}`);
        if (mts.length > 0) {
            const mtNames = mts.map(id => {
                const mt = props.userdata.allmsgtypes.find(m => ''+m.mtid === ''+id);
                return mt ? mt.Name : id;
            }).slice(0, 3); // Show first 3
            summary.push(`MT: ${mtNames.join(', ')}${mts.length > 3 ? '...' : ''}`);
        }
        return summary.length > 0 ? ` [${summary.join(' | ')}]` : '';
    };

    const ShowSkills = () => {
        let allprac = props.userdata.practices || [];
        let column1 = [];
        let column2 = [];
        if (showallprac) {
            const half = Math.ceil(allprac.length / 2);
            column1 = allprac.slice(0, half);
            column2 = allprac.slice(half);
        } else {
            allprac.forEach((prac)=> {
                const hassys = /\(([^)]+)\)/.test(prac.extended);
                const isAuthorized = !!inputs[`upopt_${prac.pracid}`];
                if (hassys || isAuthorized) {
                    column1.push(prac);
                }
            })
        }

        const renderPracItem = (prac, key) => {
            const textParts = prac.extended.split(/\(([^)]+)\)/);
            const isAuthorized = !!inputs[`upopt_${prac.pracid}`];
            const summaryStr = isAuthorized ? getSummary(prac.pracid) : '';

            return (
                <div key={key} style={{marginBottom: '10px', breakInside: 'avoid'}}>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <input 
                            type="checkbox" 
                            name={"upopt_"+prac.pracid} 
                            checked={isAuthorized} 
                            onChange={handleCheckboxChange} 
                            style={{marginTop: '4px'}}
                        />
                        <div style={{marginLeft: '8px', flex: 1}}>
                            <span 
                                style={{
                                    color: isAuthorized ? 'blue' : 'black', 
                                    cursor: isAuthorized ? 'pointer' : 'default', 
                                    textDecoration: isAuthorized ? 'underline' : 'none',
                                    fontWeight: isAuthorized ? '600' : 'normal',
                                    fontSize: '13px'
                                }}
                                onClick={(e) => {
                                    if (isAuthorized) {
                                        e.preventDefault();
                                        setEditingPrac(prac);
                                    }
                                }}
                            >
                                {textParts.map((part, index) => {
                                    if (index % 2 === 1) {
                                        return <span key={index} style={{ color: 'green' }}>({part})</span>;
                                    }
                                    return <span key={index}>{part}</span>;
                                })}
                            </span>
                            {summaryStr && (
                                <div style={{
                                    fontSize: '11px', 
                                    color: '#666', 
                                    fontStyle: 'italic', 
                                    marginTop: '1px',
                                    lineHeight: '1.2'
                                }}>
                                    {summaryStr}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        };

        return <React.Fragment>
            <div className={styles.sysskillshdr} style={{borderBottom:"1px solid black", paddingBottom: '5px', marginTop: '20px'}}>
                <div style={{fontWeight: 'bold'}}>Practice Skills:</div>
                <div style={{marginLeft:"20px", fontSize: '12px', color: '#555'}}>(Click name to configure)</div>
                <div style={{marginLeft:"auto"}}>
                    <label style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
                        <input type="checkbox" checked={showallprac} onChange={(e)=>setShowAllPrac(e.target.checked)} />
                        <span style={{marginLeft: '5px'}}>Show All Practices</span>
                    </label>
                </div>
            </div>
            <div style={{
                display: 'grid', 
                gridTemplateColumns: showallprac ? '1fr 1fr' : '1fr', 
                gap: '0 25px',
                marginTop: '10px'
            }}>
                <div>
                    {column1.map((prac,i) => renderPracItem(prac, "allprac1_"+i))}
                </div>
                {showallprac && (
                    <div>
                        {column2.map((prac,i) => renderPracItem(prac, "allprac2_"+i))}
                    </div>
                )}
            </div>
            <div style={{marginTop: '5px', borderTop: '1px solid #eee', paddingTop: '5px'}}>
                <button 
                    style={{
                        padding: '2px 10px',
                        fontSize: '12px',
                        cursor: 'pointer'
                    }} 
                    onClick={(e)=>checkAllPrac(false)}
                >Clear All Selected Practices</button>
            </div>
        </React.Fragment>
    }


    const ShowSkillsSystems = () => {
        let usersys = props.user.systemskills || [];
        let allsys = props.userdata.allsystems || [];

        return <React.Fragment>
            <div className={styles.svcskillshdr}><div>Skills:</div></div>
                <div style={{marginLeft:"50px"}}>
                {allsys.map((sys,i)=> {
                    return (
                        <div key={"allsys_"+i} className={styles.svcskillsrow}>
                        <label style={{userSelect:"none"}}>
                        <input type="checkbox" name={"sysopt_"+sys.stid} checked={!!inputs["sysopt_"+sys.stid]} onChange={handleCheckboxChange} />{sys.stdesc}</label>
                        </div>
                    )
                })}
                </div>
        </React.Fragment>
    }

    const ShowSkillsOLD = () => {
        let allsvc = props.userdata.allservices || [];
        let allsys = props.userdata.allsystems || [];
        let allmt = props.userdata.allmsgtypes || [];
        if (allsvc.length < 1 && allsys.length < 1) return null;
        let usersvc = props.user.services || [];
        let pracs = props.userdata.practices || [];
        let pracmt = props.userdata.practicemsgtypes || [];
        let usersys = props.user.systemskills || [];


        const handleSelAssign = (event) => {
            const selectedValues = Array.from(event.target.selectedOptions, option => option.value);
            setSelAssigned(selectedValues);
        }

        const handleRemove = (event) => {
            //const selectedValues = Array.from(event.target.selectedOptions, option => option.value);
            let selagn = [];
            selassigned.forEach((s)=> {
                let sa = s.split('_');
                selagn.push({mtid:sa[0],pracid:sa[1]});
            })
            let agn = authorized.filter(item => !selagn.some(obj => obj.mtid===item.mtid && obj.pracid===item.pracid));
            setSelAssigned([]);
            setAuthorized(agn);
        }

        const handleAuth = (e) => {
            e.preventDefault();
            let asg = JSON.parse(JSON.stringify(authorized));
            let pid = ''+selprac;
            let sid = ''+selsys;
            let ok = true;
            asg.every((a)=> {
                if (''+a.mtid===sid && ''+a.pracid===pid) {
                    ok = false;
                    return false;
                }
                return true;
            })

            if (!ok) {
                AlertBox("Duplicate assignment.");
                return;
            }
            asg.push({mtid:sid,pracid:pid});
            setAuthorized(asg);
        }

        const buildText = (asg) => {
            let txt = "";
            let pname = props.userdata.indexedpractices[asg.pracid] || "?";
            pname = pname.slice(0,45);
            let sname = props.userdata.indexedmsgtypes[asg.mtid] || "?";
            txt = pname + " ("+sname+")";
            return txt;
        }

        const changePractice = (e) => {
            const pid = e.target.value;
            setSelPrac(pid);
            setSelSys(0);
        }

        const buildPracticeSel = () => {
            let foundpracs = [];
            let foundpids = [];
            pracmt.forEach((p)=> {
                if (inputs["svcopt_"+p.mtid]===true) {
                    if (!foundpids.includes(p.pracid)) {
                        foundpracs.push({pracid:p.pracid,name:props.userdata.indexedpractices[p.pracid]});
                        foundpids.push(p.pracid);
                    }
                }
            })
            foundpracs.sort((a,b)=>{
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            })
            return foundpracs;
        }

        const buildSkillSel = () => {
            let foundmsgtypes = [];
            let pmt = [];
            pracmt.forEach((p)=> {
                if (''+p.pracid===selprac) {
                    pmt.push(''+p.mtid)
                }
            })
            allmt.forEach((mt)=> {
                if (pmt.includes(mt.mtid)) {
                    if (inputs["svcopt_"+mt.mtid]===true) {
                        foundmsgtypes.push({mtid:mt.mtid,Name:mt.Name});
                    }
                }
            })
            return foundmsgtypes;
        }

        const selectedpractice = '' + selprac;
        const selectedsystem = '' + selsys;
        const remdis = selectedpractice === '0' || selectedsystem === '0';
        return <React.Fragment>
            <div className={styles.svcskillshdr}><div>Skills</div></div>
            <div className={styles.svcskillsrow}>
            {allmt.map((svc,i)=> {
                return (
                    <label key={"allsvc_"+i}>
                    <input type="checkbox" name={"svcopt_"+svc.mtid} checked={!!inputs["svcopt_"+svc.mtid]} onChange={handleCheckboxChange} />{svc.Name}</label>
                )
            })}
            </div>
            <div className={styles.skillstitle}>Authorized Accounts</div>
            <div className={styles.skillshdr}>
                <div>Practices</div>
                <div>Skill</div>
                <div>Actions</div>
                <div>Authorized</div>
            </div>
            <div className={styles.skillsrow}>
                <div>
                    <select name="selprac" style={{width:"340px"}} value={selprac} onChange={changePractice}>
                        <option value="0"></option>
                        {buildPracticeSel().map((p,i)=> {
                            return (<option key={"sp_"+i} value={p.pracid}>{p.name}</option>)
                        })}
                    </select>
                </div>
                <div>
                    <select name="selsys" style={{width:"100px"}} value={selsys} onChange={(e)=>setSelSys(e.target.value)}>
                    <option value="0"></option>
                        {buildSkillSel().map((sk,i) => {
                            return (<option key={"ss_"+i} value={sk.mtid}>{sk.Name}</option>)
                        })}
                    </select>
                </div>
                <div>
                    <div><button style={{width:"80px"}} onClick={handleAuth} disabled={remdis}>Authorize</button></div>
                    <div><button style={{marginTop:"10px",width:"80px"}} onClick={handleRemove}>Remove</button></div>
                </div>
                <div>
                    <select name="selassigned" multiple style={{height:"100px",width:"350px"}} onChange={handleSelAssign} value={selassigned}>
                        {authorized.map((obj,i) => {
                            let aname = buildText(obj);
                            let newobj = ""+obj.mtid+"_"+obj.pracid;
                            return (
                                <option key={"asg_"+i} value={newobj}>{aname}</option>
                            )
                        })}
                    </select>
                </div>
            </div>

        </React.Fragment>
    }


    const OLD_ShowRequiredSkills = () => {
        const langs = [
            { code: "en", name: "English" },
            { code: "sp", name: "Spanish" },
        ];

        const allSystems = props.userdata.allsystems || [];
        const emrSystems = allSystems
            .map((sys) => sys.stid)
            .filter((id) => id);

        const handleLanguageChange = (e) => {
            setSkills((prev) => ({
            ...prev,
            languages: e.target.value,
            }));
        };

        const handleEmrChange = (e) => {
            const sysId = e.target.value;
            const checked = e.target.checked;
            const current = skills.emr_systems || [];

            let next;
            if (checked) {
            next = current.includes(sysId) ? current : [...current, sysId];
            } else {
            next = current.filter((id) => id !== sysId);
            }

            setSkills((prev) => ({
            ...prev,
            emr_systems: next,
            }));
        };

        return (
            <>
            <div
                className={styles.sysskillshdr}
                style={{ borderBottom: "1px solid black" }}
            >
                Global Skills:
            </div>
            <div style={{ marginLeft: "50px" }}>
                {/* Human‑Only (label before checkbox) */}
                <div className={styles.svcskillsrow}>
                <label style={{ userSelect: "none", display: "flex", alignItems: "center" }}>
                    Human‑Only:&nbsp;
                    <input
                    type="checkbox"
                    name="human-only"
                    checked={!!skills["human-only"]}
                    onChange={(e) =>
                        setSkills((prev) => ({
                        ...prev,
                        "human-only": e.target.checked,
                        }))
                    }
                    />
                </label>
                </div>

                {/* Language dropdown */}
                <div className={styles.svcskillsrow}>
                <label style={{ userSelect: "none" }}>
                    Language:&nbsp;
                    <select
                    value={skills.languages}
                    onChange={handleLanguageChange}
                    style={{ width: "120px" }}
                    >
                    {langs.map((lang) => (
                        <option key={lang.code} value={lang.code}>
                        {lang.name}
                        </option>
                    ))}
                    </select>
                </label>
                </div>
            </div>
            </>
        );
    };

    const ensureArray = (value) => {
        return Array.isArray(value) ? value : [value];
    }
    const ShowRequiredSkills = () => {
        const langs = [
            { code: "en", name: "English" },
            { code: "sp", name: "Spanish" },
        ];
        let userlangs = ensureArray(skills.languages || []);

        const handleLangChange = (e) => {
            const langcode = e.target.value;
            const checked = e.target.checked;
            const current = ensureArray(skills.languages || []);
            let next;
            if (checked) {
                next = current.includes(langcode) ? current : [...current,langcode];

            } else {
                next = current.filter((id) =>  id != langcode);
            }
            setSkills((prev) => ({
                ...prev,
                languages: next,
            }));
        }

        return (
            <>
            <div
                className={styles.sysskillshdr}
                style={{ borderBottom: "1px solid black" }}
            >
                Global Skills:
            </div>
            <div style={{ marginLeft: "50px" }}>
                {/* Human‑Only (label before checkbox) */}
                <div className={styles.svcskillsrow}>
                <label style={{ userSelect: "none", display: "flex", alignItems: "center" }}>
                    Human‑Only:&nbsp;
                    <input
                    type="checkbox"
                    name="human-only"
                    checked={!!skills["human-only"]}
                    onChange={(e) =>
                        setSkills((prev) => ({
                        ...prev,
                        "human-only": e.target.checked,
                        }))
                    }
                    />
                </label>
                </div>

                {/* Language dropdown removed, keeping checkboxes */}
                <div className={styles.svcskillsrow}>
                <label style={{ userSelect: "none" }}>
                    Language:&nbsp;
                    <div
                        style={{
                            display: "block",
                            marginLeft: "20px",
                        }}
                    >
                        {langs.map((lang) => (
                            <label key={lang.code} style={{ userSelect: "none", display: "flex" }}>
                                <div style={{ width: "18px" }}>
                                    <input 
                                    type="checkbox"
                                    value={lang.code} 
                                    checked={userlangs.includes(lang.code)}
                                    onChange={handleLangChange}
                                    />
                                </div>
                                <div style={{ marginLeft: "4px" }}>{lang.name}</div>
                            </label>
                        ))}

                    </div>
                </label>
                </div>
            </div>
            </>
        );
    };

    const PracticeSkillDialog = () => {
        if (!editingPrac) return null;
        const pracid = '' + editingPrac.pracid;
        const pSkills = skills.practices[pracid] || { emr: [], message_types: [] };
        
        const allowedMTs = (props.userdata.practicemsgtypes || [])
            .filter(p => ''+p.pracid === pracid)
            .map(p => ''+p.mtid);

        const allMTs = props.userdata.allmsgtypes || [];

        const handleMTChange = (mtid, checked) => {
            const currentMTs = pSkills.message_types || [];
            let nextMTs;
            if (checked) {
                nextMTs = currentMTs.includes(mtid) ? currentMTs : [...currentMTs, mtid];
            } else {
                nextMTs = currentMTs.filter(id => id !== mtid);
            }
            setSkills(prev => ({
                ...prev,
                practices: {
                    ...prev.practices,
                    [pracid]: { ...pSkills, message_types: nextMTs }
                }
            }));
        };

        const handleMTSelectAll = (isSelectAll) => {
            const nextMTs = isSelectAll ? allowedMTs : [];
            setSkills(prev => ({
                ...prev,
                practices: {
                    ...prev.practices,
                    [pracid]: { ...pSkills, message_types: nextMTs }
                }
            }));
        };

        const handleEMRChange = (emrName, checked) => {
            const currentEMRs = pSkills.emr || [];
            let nextEMRs;
            if (checked) {
                nextEMRs = currentEMRs.includes(emrName) ? currentEMRs : [...currentEMRs, emrName];
            } else {
                nextEMRs = currentEMRs.filter(name => name !== emrName);
            }
            setSkills(prev => ({
                ...prev,
                practices: {
                    ...prev.practices,
                    [pracid]: { ...pSkills, emr: nextEMRs }
                }
            }));
        };

        const pracEMRs = [];
        const matches = editingPrac.extended.match(/\(([^)]+)\)/g);
        if (matches) {
            matches.forEach(m => {
                const name = m.slice(1, -1);
                if (!pracEMRs.includes(name)) pracEMRs.push(name);
            });
        }

        return (
            <div className={styles.detail} style={{zIndex: 10000000}}>
                <div className={styles.outer} style={{width: '660px'}}>
                    <div className={styles.inner}>
                        <div className={styles.detailheader}>
                            <div>Skills for {editingPrac.name}</div>
                            <div className={styles.headerright} onClick={() => setEditingPrac(null)}><Closer /></div>
                        </div>

                        <div style={{marginTop: '20px'}}>
                            <label style={{display: 'flex', alignItems: 'center', userSelect: 'none', fontWeight: 'bold'}}>
                                <input 
                                    type="checkbox" 
                                    checked={!!pSkills.holding}
                                    onChange={(e) => {
                                        setSkills(prev => ({
                                            ...prev,
                                            practices: {
                                                ...prev.practices,
                                                [pracid]: { ...pSkills, holding: e.target.checked }
                                            }
                                        }));
                                    }}
                                /> Accepts Holding Calls
                            </label>
                        </div>
                        
                        <div style={{marginTop: '20px'}}>
                            <strong>EMR Systems:</strong>
                            <div style={{marginLeft: '20px', marginTop: '10px'}}>
                                {pracEMRs.map(name => (
                                    <label key={name} style={{display: 'block', userSelect: 'none'}}>
                                        <input 
                                            type="checkbox" 
                                            checked={(pSkills.emr || []).includes(name)}
                                            onChange={(e) => handleEMRChange(name, e.target.checked)}
                                        /> {name}
                                    </label>
                                ))}
                                {pracEMRs.length === 0 && <div>No EMR systems defined for this practice.</div>}
                            </div>
                        </div>

                        <div style={{marginTop: '20px'}}>
                            <strong>Message Type Skills:</strong>
                            <div style={{marginLeft: '20px', marginTop: '5px', fontSize: '12px'}}>
                                <span 
                                    style={{color: 'blue', cursor: 'pointer', textDecoration: 'underline'}}
                                    onClick={() => handleMTSelectAll(true)}
                                >Select All Available</span>
                                <span style={{margin: '0 10px'}}>|</span>
                                <span 
                                    style={{color: 'blue', cursor: 'pointer', textDecoration: 'underline'}}
                                    onClick={() => handleMTSelectAll(false)}
                                >Clear All</span>
                            </div>
                            <div style={{marginLeft: '20px', marginTop: '10px', maxHeight: '300px', overflowY: 'auto', border: '1px solid lightgray', padding: '10px'}}>
                                {allMTs.map(mt => {
                                    if (mt.mtid === '0') return null;
                                    const isAllowed = allowedMTs.includes(''+mt.mtid);
                                    const isChecked = (pSkills.message_types || []).includes(''+mt.mtid);
                                    return (
                                        <div key={mt.mtid} style={{color: isAllowed ? 'black' : 'gray', marginBottom: '4px'}}>
                                            <label style={{display: 'flex', alignItems: 'center', userSelect: 'none'}}>
                                                <input 
                                                    type="checkbox" 
                                                    disabled={!isAllowed}
                                                    checked={isChecked}
                                                    onChange={(e) => handleMTChange(''+mt.mtid, e.target.checked)}
                                                />
                                                <span style={{marginLeft: '5px', textDecoration: isAllowed ? 'none' : 'line-through'}}>{mt.Name}</span>
                                                {!isAllowed && <span style={{marginLeft: '10px', fontSize: '10px'}}>(Not supported by practice)</span>}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        <div style={{marginTop: '30px', textAlign: 'center'}}>
                            <GenButton width="100" buttontext="Done" onclick={() => setEditingPrac(null)} />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    let active = props.user.ActiveFlag === 'Y';
    let practiceid = '' + props.globals.practiceid;

    return (
        <div className={styles.detail}>
            {editingPrac && <PracticeSkillDialog />}
            <div className={styles.outer}>
                <div className={styles.inner}>
                    <div className={styles.detailheader}>
                        <div>User details ({props.user.UserAccountID})</div>
                        <div className={styles.headerright} onClick={onClose}><Closer /></div>
                    </div>
                    <div className={styles.lefthalf}>
                        <div className={styles.listrowhdr}>
                            <div>Last Name</div>
                            <div>First Name</div>
                            <div>Middle Initial</div>
                        </div>
                        <div className={styles.listrow}>
                            <div><input type="text" maxLength="30" name="lastname" ref={lnref} defaultValue={props.user.LastName} /></div>
                            <div><input type="text" maxLength="20" name="firstname" ref={fnref} defaultValue={props.user.FirstName} /></div>
                            <div><input type="text" maxLength="1" name="midinit" ref={miref} defaultValue={props.user.MiddleInitial} /></div>
                        </div>
                        <div className={styles.listrowhdr}>
                            <div>User ID</div>
                            <div>Email</div>
                            <div>Default Location</div>
                        </div>
                        <div className={styles.listrow}>
                            <div><input type="text" maxLength="20" name="userid" ref={unref} defaultValue={props.user.Username} /></div>
                            <div><input type="text" maxLength="30" name="email" autoComplete="new-password" ref={emref} defaultValue={props.user.Email} /></div>
                            <div>
                                <ShowLocations />
                            </div>
                        </div>
                        <div className={styles.listrowhdr}>
                            <div>Role</div>
                            <div>Password</div>
                            <div>Confirm Password</div>
                        </div>
                        <div className={styles.listrow}>
                            <div>
                                <ShowRoles />
                            </div>
                            <div><input type="password" maxLength="30" autoComplete="new-password" name="upwd" ref={pwref} /></div>
                            <div><input type="password" maxLength="30" autoComplete="new-password" name="confpwd" ref={pwcref} /></div>
                        </div>
                        <div className={styles.listrowhdr}>
                            <div style={{width:"190px",fontSize:"14px"}}>Active</div>
                            <div style={{width:"190px",fontSize:"14px"}}>Force Password Change</div>
                            {practiceid==='1' && <div style={{width:"220px",fontSize:"14px",whiteSpace:"pre"}}>Phone Queue ID  /  Phone Number</div>}
                        </div>
                        <div className={styles.listrow}>
                            <div>
                                <label>
                                <input type="radio" name="active" id="activeyes" ref={acrefy} defaultChecked={active===true} />
                                Yes
                                </label>
                                <label style={{marginLeft:"10px"}}>
                                <input type="radio" name="active" id="activeno" ref={acrefn} defaultChecked={active===false} />
                                No
                                </label>
                            </div>
                            <div>
                                <label>
                                <input type="radio" name="forcepw" id="fpwyes" ref={fprefy} defaultChecked={false} />
                                Yes
                                </label>
                                <label style={{marginLeft:"10px"}}>
                                <input type="radio" name="forcepw" id="fpwno" ref={fprefn} defaultChecked={true} />
                                No
                                </label>
                            </div>
                            {practiceid==='1' && <div><input type="text" style={{width:"95px"}} maxLength="30" name="queueid" ref={qidref} defaultValue={props.user.queueid} /> / <input type="text" style={{width:"120px"}} maxLength="30" name="queuephone" ref={qphref} defaultValue={props.user.queuephone} /></div>}
                        </div>
                        {practiceid==='1' && ShowSkills()}
                        {practiceid === '1' && ShowRequiredSkills()}
                        <div className={styles.selecthdr} style={{display:"flex"}}>

                        </div>
                    </div>
                    <div className={styles.righthalf}>
                        <Buttons />
                    </div>
                </div>
            </div> 
        </div> 

    )
}

export default UserDetail;